"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedFetchInit = void 0;
const enhancedFetch_1 = require("./enhancedFetch");
const Journey_1 = require("./Journey");
const ResponseCookie_1 = require("./ResponseCookie");
const urls_1 = require("./urls");
const helpers_1 = require("./helpers");
class EnhancedFetchInit {
    constructor(url, init) {
        var _a;
        this.attributes = Object.assign(Object.assign({}, init), { url, method: (_a = init.method) !== null && _a !== void 0 ? _a : 'GET' });
    }
    sanitizedAttributes() {
        const attributes = Object.assign(Object.assign({}, this.attributes), { body: this.sanitizeBodyAttributes(this.attributes.body), url: this.sanitizeUrlAttribute(this.attributes.url) });
        if (this.isExternalDomainRequest()) {
            attributes.credentials = undefined;
        }
        return attributes;
    }
    sanitizeHeaders(headers) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const sanitizedHeaders = Object.assign({}, headers);
            const methods = new Set(['PUT', 'POST', 'DELETE', 'PATCH']);
            // on client, requests automatically include cookies so we just need to setup the forwarded xsrf token.
            if (helpers_1.isClient()) {
                if (Journey_1.Journey.config.csrfCookieUrl && methods.has(this.attributes.method)) {
                    sanitizedHeaders['X-XSRF-TOKEN'] = yield ResponseCookie_1.getXsrfToken();
                }
            }
            else if ((_c = (_b = (_a = this.attributes.ssrContext) === null || _a === void 0 ? void 0 : _a.req) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.cookie) {
                if (methods.has(this.attributes.method)) {
                    // todo: POSTing doesnt work since we dont fetch an xsrf token on serverside props yet.
                    console.error(`POST requests (${this.attributes.url}) are currently not supported in SSR.`);
                }
                /*
                *   Not sure what to do here, Laravel SSR request for authentication REQUIRES a "referer" header.
                *   Netlify gives us an SSL issue if we provide anything other than just the "cookie" header.
                *   We also cant just dump all the headers or else it causes 401 unauthorized issues (POS) (probably Host header)
                */
                // on the server, we just wanna forward the cookies/referer provided from the ssrRequest
                sanitizedHeaders.cookie = this.attributes.ssrContext.req.headers.cookie;
                sanitizedHeaders.referer = this.attributes.ssrContext.req.headers.referer;
                sanitizedHeaders['X-Forwarded-Host'] = this.attributes.ssrContext.req.headers['x-forwarded-host'];
                sanitizedHeaders['X-Forwarded-For'] = this.attributes.ssrContext.req.headers['x-forwarded-for'];
            }
            return sanitizedHeaders;
        });
    }
    isExternalDomainRequest() {
        const { url } = this.attributes;
        return url.startsWith('http://') || url.startsWith('https://');
    }
    sanitizeUrlAttribute(url) {
        const { method, body } = this.attributes;
        if (method === 'GET' && !!body && typeof body === 'object') {
            return urls_1.createUrl(url, body);
        }
        return url;
    }
    sanitizeBodyAttributes(body) {
        const { method } = this.attributes;
        let newBody = body;
        if (newBody && typeof newBody === 'object') {
            newBody = enhancedFetch_1.isFormData(newBody) ? newBody : Object.assign({}, newBody); // prevent mutation of actual body object.
        }
        const fileKeys = enhancedFetch_1.getFileKeys(newBody !== null && newBody !== void 0 ? newBody : {});
        if (fileKeys.length > 0) {
            const formData = new FormData();
            fileKeys.forEach((fileKey) => {
                const value = newBody[fileKey];
                const hasMultipleFiles = Array.isArray(value) || value instanceof FileList;
                let files = hasMultipleFiles ? value : [value];
                if (value instanceof FileList) {
                    files = [...value];
                }
                // turns "images" to "images[]", only if file value was originally an array.
                if (hasMultipleFiles) {
                    fileKey += '[]';
                }
                files.forEach((file) => {
                    formData.append(fileKey, file);
                });
            });
            Object.keys(newBody).filter((k) => !fileKeys.includes(k)).forEach((key) => {
                const value = newBody[key];
                /* FormData's null values actually encodes into "null" */
                if (value !== null) {
                    formData.append(key, value);
                }
            });
            newBody = formData;
        }
        // body provided, but we are using GET.
        if (method === 'GET' && !!newBody && typeof newBody === 'object') {
            newBody = undefined;
        }
        if (method !== 'GET' && newBody !== undefined && (typeof newBody !== 'string' && !enhancedFetch_1.isFormData(newBody))) {
            newBody = JSON.stringify(newBody);
        }
        return newBody;
    }
}
exports.EnhancedFetchInit = EnhancedFetchInit;
